import ThumbDownOutline from './ThumbDownOutline'

export default ThumbDownOutline
// eslint-disable-next-line import/export
export * from './ThumbDownOutline'
